<template>
  <div v-if="list.length" :class="['aside-post__interesting-posts', className]">
    <div v-if="title.length" class="aside-post__title t1">{{ title }}</div>
    <div class="aside-post__scroll-x">
      <div class="interesting-posts">
        <div class="interesting-posts__list">
          <div v-for="item in list" :key="item.id" class="interesting-posts__item">
            <a class="interesting-posts__title t3" :href="item['LINK']">
              {{ item['NAME'] }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <Button class="-full" size="-m" variant="-outline" href="/expertise/">{{
      t('a_interesting_posts_more')
    }}</Button>
  </div>
</template>

<script setup lang="ts">
  // import
  import { computed, reactive, useI18n } from '#imports';
  import { Button } from '@nuxt-shared/ui/button';
  const { t } = useI18n({ useScope: 'local' });

  // props
  const { className, list } = defineProps({
    className: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  });

  // computed
  const title = computed(() => t('a_side_title_interesting_posts'));
</script>

<style scoped lang="scss">
  .interesting-posts {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    padding-bottom: 24px;

    &__list {
      display: flex;
      flex-direction: column;
      row-gap: 32px;

      @include until($lg) {
        padding-right: 64px;
        padding-left: 64px;
        flex-wrap: initial;
        flex-direction: row;
        width: min-content;
        column-gap: 24px;
      }

      @include until($md) {
        padding-right: 24px;
        padding-left: 24px;
        column-gap: 12px;
      }
    }

    &__item {
      @include until($lg) {
        width: 225px;
      }

      @include until($md) {
        width: 242px;
      }
    }

    &__title {
      font-weight: var(--font-weight-medium);
      &:hover {
        color: var(--color-accent-primary);
      }
    }
  }
</style>

<i18n lang="json">
{
  "ru": {
    "a_side_title_interesting_posts": "Вам может быть интересно",
    "a_interesting_posts_more": "Все публикации"
  }
}
</i18n>
